var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Loader2 } from "lucide-react";
import { StepType } from "@/components/appointments/steps/StepType";
import { StepDate } from "@/components/appointments/steps/StepDate";
import { StepTime } from "@/components/appointments/steps/StepTime";
import { StepInfo } from "@/components/appointments/steps/StepInfo";
import { StepConfirmation } from "@/components/appointments/steps/StepConfirmation";
import { format } from "date-fns";
var initialFormData = {
    tourType: "0",
    appointmentDate: undefined,
    appointmentTime: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    preferredContactMethod: "",
    middleName: "",
    message: "",
    desiredMoveinDate: "",
    desiredBedrooms: 0,
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    subscribeToEmails: false,
};
var steps = [
    { id: 1, name: "Select Tour Type" },
    { id: 2, name: "Select Date" },
    { id: 3, name: "Select Time" },
    { id: 4, name: "Your Information" },
];
export var AppointmentsContainer = function () {
    var _a = useState(1), currentStep = _a[0], setCurrentStep = _a[1];
    var _b = useState(initialFormData), formData = _b[0], setFormData = _b[1];
    var _c = useState(false), isSubmitted = _c[0], setIsSubmitted = _c[1];
    var _d = useState(), appointmentId = _d[0], setAppointmentId = _d[1];
    var _e = useState(), prospectId = _e[0], setProspectId = _e[1];
    var _f = useState([]), tourTypes = _f[0], setTourTypes = _f[1];
    // Debug
    var _g = useState(false), isApptCanceled = _g[0], setIsApptCanceled = _g[1];
    // API data
    var _h = useState([]), availableSlots = _h[0], setAvailableSlots = _h[1];
    var _j = useState(true), isLoadingSlots = _j[0], setIsLoadingSlots = _j[1];
    var _k = useState(null), formFields = _k[0], setFormFields = _k[1];
    var _l = useState(true), isLoadingFormFields = _l[0], setIsLoadingFormFields = _l[1];
    var _m = useState(null), settings = _m[0], setSettings = _m[1];
    var _o = useState(true), isLoadingSettings = _o[0], setIsLoadingSettings = _o[1];
    var _p = useState(null), error = _p[0], setError = _p[1];
    // Fetch available slots, form fields, and settings on mount
    useEffect(function () {
        fetchAvailableSlots();
        fetchFormFields();
        fetchSettings();
    }, []);
    var fetchAvailableSlots = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, result, err_1, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoadingSlots(true);
                    setError(null);
                    return [4 /*yield*/, fetch("/wp-json/harmony/v1/appointments/available-slots?days=30", {
                            headers: {
                                "X-WP-Nonce": window.harmonyFrontend.nonce,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Failed to fetch available slots: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    if (!result.success) {
                        throw new Error(result.errorMessage);
                    }
                    else {
                        setAvailableSlots(result.slots);
                        setTourTypes(result.tourTypes);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    errorMessage = err_1 instanceof Error
                        ? err_1.message
                        : "Failed to load available appointment times. Please refresh the page.";
                    setError(errorMessage);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingSlots(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var fetchFormFields = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, result, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoadingFormFields(true);
                    return [4 /*yield*/, fetch("/wp-json/harmony/v1/appointments/form-fields", {
                            headers: {
                                "X-WP-Nonce": window.harmonyFrontend.nonce,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Failed to fetch form fields");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    if (result.success && result.data) {
                        setFormFields(result.data);
                    }
                    else {
                        throw new Error("Invalid form fields response");
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    console.error("Error fetching form fields:", err_2);
                    setError("Failed to load form configuration. Please refresh the page.");
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingFormFields(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var fetchSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, result, err_3, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoadingSettings(true);
                    return [4 /*yield*/, fetch("/wp-json/harmony/v1/appointments/settings", {
                            headers: {
                                "X-WP-Nonce": window.harmonyFrontend.nonce,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Failed to fetch settings: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    if (!result.success) {
                        throw new Error(result.errorMessage);
                    }
                    else {
                        setSettings({
                            appointmentFormTitle: result.appointmentFormTitle,
                            appointmentFormDescription: result.appointmentFormDescription,
                            appointmentFormSuccessMessage: result.appointmentFormSuccessMessage,
                        });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _a.sent();
                    errorMessage = err_3 instanceof Error
                        ? err_3.message
                        : "Unknown error while fetching appointment settings.";
                    console.error(errorMessage);
                    setError("Failed to fetch settings. Please refresh the page.");
                    setSettings(null);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingSettings(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onDebugCancelApt = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, result, err_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!appointmentId) {
                        console.log("Cannot cancel apt, no ID available");
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetch("/wp-json/harmony/v1/appointments/".concat(appointmentId), {
                            method: "PATCH",
                            headers: {
                                "Content-Type": "application/json",
                                "X-WP-Nonce": window.harmonyFrontend.nonce,
                            },
                            body: JSON.stringify({
                                id: appointmentId,
                                prospectId: prospectId,
                                operation: "cancel",
                            }),
                        })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) {
                        throw new Error("Failed to cancel appointment: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _b.sent();
                    if (!result.success) {
                        throw new Error(result.errorMessage || "Failed to cancel appointment");
                    }
                    console.log("Appointment ".concat(appointmentId, " has been canceled."));
                    setIsApptCanceled((_a = result.isApptCanceled) !== null && _a !== void 0 ? _a : false);
                    return [3 /*break*/, 4];
                case 3:
                    err_4 = _b.sent();
                    if (err_4 instanceof Error) {
                        console.error(err_4.message);
                        setError(err_4.message);
                    }
                    else {
                        setError("Failed to cancel appointment");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleNext = function () {
        if (currentStep < steps.length) {
            setCurrentStep(function (prev) { return prev + 1; });
        }
    };
    var handleBack = function () {
        if (currentStep > 1) {
            setCurrentStep(function (prev) { return prev - 1; });
        }
    };
    var updateFormData = function (newData) {
        setFormData(function (prev) { return (__assign(__assign({}, prev), newData)); });
    };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var appointmentData, response, result, err_5, errorMessage;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    setError(null);
                    appointmentData = {
                        firstName: formData.firstName,
                        lastName: formData.lastName,
                        email: formData.email,
                        phone: formData.phone,
                        appointmentDate: formData.appointmentDate
                            ? format(formData.appointmentDate, "MM/dd/yyyy")
                            : "",
                        appointmentTime: formData.appointmentTime,
                        tourType: formData.tourType,
                        preferredContactMethod: formData.preferredContactMethod,
                        message: formData.message,
                        subscribeToEmails: formData.subscribeToEmails,
                    };
                    return [4 /*yield*/, fetch("/wp-json/harmony/v1/appointments", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-WP-Nonce": window.harmonyFrontend.nonce,
                            },
                            body: JSON.stringify(appointmentData),
                        })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) {
                        throw new Error("Failed to create appointment: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _b.sent();
                    if (!result.success) {
                        throw new Error((_a = result.errorMessage) !== null && _a !== void 0 ? _a : "Failed to create appointment");
                    }
                    setAppointmentId(result.appointmentId);
                    setProspectId(result.prospectId);
                    setIsSubmitted(true);
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _b.sent();
                    errorMessage = err_5 instanceof Error ? err_5.message : "Failed to create appointment";
                    console.error(errorMessage);
                    setError(errorMessage);
                    throw err_5; // Re-throw to let StepInfo handle the error state
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var resetForm = function () {
        setCurrentStep(1);
        setFormData(initialFormData);
        setIsSubmitted(false);
        setAppointmentId(undefined);
        setProspectId(undefined);
        setError(null);
    };
    var resetFormAndFetchData = function () {
        resetForm();
        fetchAvailableSlots();
        fetchFormFields();
        fetchSettings();
    };
    var progress = (currentStep / steps.length) * 100;
    var isLoading = isLoadingSlots || isLoadingFormFields || isLoadingSettings;
    if (isLoading) {
        return (React.createElement("div", { className: "container mx-auto p-4" },
            React.createElement(Card, null,
                React.createElement(CardContent, { className: "flex flex-col items-center justify-center py-12" },
                    React.createElement(Loader2, { className: "h-8 w-8 animate-spin text-primary mb-4" }),
                    React.createElement("p", { className: "text-muted-foreground" }, "Loading appointment booking form...")))));
    }
    if (error && !isSubmitted) {
        return (React.createElement("div", { className: "container mx-auto p-4" },
            React.createElement(Card, null,
                React.createElement(CardContent, { className: "py-12" },
                    React.createElement("div", { className: "text-center" },
                        React.createElement("p", { className: "text-red-500 mb-4" }, error),
                        React.createElement(Button, { onClick: function () {
                                fetchAvailableSlots();
                                fetchFormFields();
                                fetchSettings();
                            } }, "Try Again"))))));
    }
    return (React.createElement("div", { className: "container mx-auto p-4" },
        React.createElement(Card, { className: "w-full max-w-3xl mx-auto overflow-hidden" },
            React.createElement("div", { className: "p-6 border-b" },
                React.createElement("div", { className: "flex items-center justify-between" },
                    React.createElement("h2", { className: "text-2xl font-bold" }, (settings === null || settings === void 0 ? void 0 : settings.appointmentFormTitle) || "Book a Tour"),
                    !isSubmitted && (React.createElement("div", { className: "text-sm text-muted-foreground" },
                        "Step ",
                        currentStep,
                        " of ",
                        steps.length))),
                !isSubmitted &&
                    currentStep === 1 &&
                    (settings === null || settings === void 0 ? void 0 : settings.appointmentFormDescription) && (React.createElement("p", { className: "text-muted-foreground mt-2" }, settings.appointmentFormDescription)),
                !isSubmitted && currentStep !== 1 && (React.createElement("p", { className: "text-muted-foreground mt-1" }, steps[currentStep - 1].name))),
            !isSubmitted && (React.createElement("div", { className: "px-6 pt-2 pb-4" },
                React.createElement(Progress, { value: progress, className: "h-1" }))),
            React.createElement(CardContent, { className: "p-6" }, isSubmitted ? (React.createElement(StepConfirmation, { formData: formData, appointmentId: appointmentId, prospectId: prospectId, isApptCanceled: isApptCanceled, successMessage: settings === null || settings === void 0 ? void 0 : settings.appointmentFormSuccessMessage, onDebugCancelApt: onDebugCancelApt, onReset: resetFormAndFetchData })) : (React.createElement(React.Fragment, null,
                currentStep === 1 && (React.createElement(StepType, { formData: formData, tourTypes: tourTypes, onUpdate: updateFormData, onNext: handleNext })),
                currentStep === 2 && (React.createElement(StepDate, { formData: formData, availableSlots: availableSlots, onUpdate: updateFormData, onNext: handleNext })),
                currentStep === 3 && (React.createElement(StepTime, { formData: formData, availableSlots: availableSlots, onUpdate: updateFormData, onNext: handleNext })),
                currentStep === 4 && formFields && (React.createElement(StepInfo, { formData: formData, formFields: formFields, onUpdate: updateFormData, onSubmit: handleSubmit }))))),
            !isSubmitted && currentStep > 1 && (React.createElement("div", { className: "p-6 border-t" },
                React.createElement(Button, { variant: "ghost", onClick: handleBack },
                    React.createElement(ArrowLeft, { className: "mr-2 h-4 w-4" }),
                    "Back"))))));
};
